module.exports = __webpack_public_path__ + "img/podium_5678.debd175a.jpg";